/* istanbul ignore file */

export const CHARGE_NUMBER_CONSTANTS = {
    MAX_LENGTH: 11,
};
